// RESPONSIVE BREAKPOINTS
export const breakpoint = {
  mobile: 767,
  tablet: 1280,
};

export const deviceType = {
  mobile: `(max-width: ${breakpoint.mobile}px)`,
  desktop: `(min-width: ${breakpoint.mobile}px)`,
};
